import React, { useState } from 'react';
import PropTypes from 'prop-types';
import I18n from 'utils/I18n';
import createNetworkingClient from 'utils/networking-client';

import StreamPrivacySlider from './components/StreamPrivacySlider';
import styles from './styles.scss';

function HideAnywhereApp({
  defaultStreamPrivacy: streamPrivacyProp,
  streamPrivacyOptions,
  updateSettingsPath
}) {
  const I18nPrefix = 'strava.settings.privacy.hide_anywhere.';
  const distanceUnits =
    I18n.measurementUnits() === 'metric' ? 'meters' : 'miles';
  const [defaultStreamPrivacy, setDefaultStreamPrivacy] = useState(
    streamPrivacyProp
  );
  const sliderLabels = streamPrivacyOptions.filter((s, i) => i % 2 === 0);

  const handleSettingUpdate = (radius) => {
    const oldStreamPrivacy = { ...defaultStreamPrivacy };
    const newStreamPrivacy = streamPrivacyOptions.find(
      (r) => r.meters_value === radius
    );
    setDefaultStreamPrivacy(newStreamPrivacy);
    createNetworkingClient()
      .put(updateSettingsPath, {
        settings: { default_stream_privacy: newStreamPrivacy.luggage_value }
      })
      .catch(() => {
        setDefaultStreamPrivacy(oldStreamPrivacy);
      });
  };

  return (
    <div>
      <div className={styles.detail}>{I18n.t(`${I18nPrefix}detail`)}</div>
      <div className={styles.sliderContainer}>
        <div className={styles.distanceHiddenLabel}>
          {defaultStreamPrivacy.meters_value === 0
            ? I18n.t(
                `strava.settings.privacy.distance.no_${distanceUnits}_hidden`
              )
            : I18n.t_html(
                `strava.settings.privacy.distance.${distanceUnits}_hidden`,
                {
                  distance: I18n.t(defaultStreamPrivacy.label)
                }
              )}
        </div>
        <StreamPrivacySlider
          domain={[
            0,
            streamPrivacyOptions[streamPrivacyOptions.length - 1].meters_value
          ]}
          defaultStreamPrivacy={defaultStreamPrivacy}
          onChange={handleSettingUpdate}
          numTicks={streamPrivacyOptions.length}
        />
        <div className={styles.sliderScale}>
          {sliderLabels.map((s) => (
            <div key={s.meters_value}>{I18n.t_html(s.label)}</div>
          ))}
        </div>
      </div>
      <div className={styles.segmentVisibility}>
        {I18n.t_html(`${I18nPrefix}segment_visibility_html`)}
      </div>
    </div>
  );
}

HideAnywhereApp.propTypes = {
  defaultStreamPrivacy: PropTypes.shape({
    meters_value: PropTypes.number,
    luggage_value: PropTypes.string,
    label: PropTypes.string
  }).isRequired,
  streamPrivacyOptions: PropTypes.arrayOf(
    PropTypes.shape({
      meters_value: PropTypes.number,
      luggage_value: PropTypes.string,
      label: PropTypes.string
    })
  ).isRequired,
  updateSettingsPath: PropTypes.string.isRequired
};

export default HideAnywhereApp;
